export const enum ActionsTypes {
  CustomerInformationInitializing = '[Customer Information] Initializing',
  CustomerInformationInitialized = '[Customer Information] Initialized',
  CustomerInformationInitializingError = '[Customer Information] Initialize Error',

  CustomerInformationSaveAndLoad = '[Customer Information] Save And Load',
  CustomerInformationSaveAndLoadComplete = '[Customer Information] Save And Load Complete',
  CustomerInformationSaveAndLoadError = '[Customer Information] Save And Load Error',

  CustomerInformationReload = '[Customer Information] Reload',
  CustomerInformationResetWorkflow = '[Customer Information] Reset Workflow',
  CustomerInformationTokenClear = '[Customer Information] Token Clear',
  CustomerInformationConfirmation = '[Customer Information] Confirmation',

  CustomerInformationPersist = '[Customer Information] Persist',
}
